import { render, staticRenderFns } from "./TiktokCv.vue?vue&type=template&id=710cd98d&scoped=true&"
import script from "./TiktokCv.vue?vue&type=script&lang=js&"
export * from "./TiktokCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cd98d",
  null
  
)

export default component.exports